import axios from 'axios';
import toast from 'react-hot-toast';

const resolveApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  return 'https://api.acquiva.co/api/v1';
};

const API_URL = resolveApiUrl();

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('acquiva-auth') 
      ? JSON.parse(localStorage.getItem('acquiva-auth')).state?.token 
      : null;
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error.response?.data?.error?.message || 'An error occurred';
    
    // Handle specific error codes
    if (error.response?.status === 401) {
      // Clear auth and redirect to login
      localStorage.removeItem('acquiva-auth');
      window.location.href = '/login';
    } else if (error.response?.status === 403) {
      toast.error('You do not have permission to perform this action');
    } else if (error.response?.status === 404) {
      toast.error('Resource not found');
    } else {
      toast.error(message);
    }
    
    return Promise.reject(error);
  }
);

export default api;
